module.exports = __webpack_public_path__ + "static/media/standardsquarelogo.4702f800.png";